import { useRouteMatch } from 'react-router-dom'

import { useAppSelector } from 'common/hooks/redux'

import { Campaigns } from './components/Campaigns'
import DashboardHeader from './components/DashboardHeader'
import { DataSearch } from './components/DataSearch'
import { Jaqi } from './components/Jaqi'
import { Liveboard } from './components/Liveboard'
import { MetabaseAccountOverview } from './components/MetabaseAccountOverview'
import { MetabaseCampaignOverview } from './components/MetabaseCampaignOverview'
import { useInitializeThoughtSpot } from './hooks/useInitializeThoughtSpot'
import { PAGES, PATH, THOUGHTSPOT_ROUTES } from './interfaces'

export default function Dashboard() {
  const { path } = useRouteMatch()
  const selectedPage = PAGES.find((page) => page.path === path)
  const userId = useAppSelector((state) => state.authStates.user_id)

  // Only initialize ThoughtSpot for ThoughtSpot-dependent routes
  const isThoughtSpotRoute = (THOUGHTSPOT_ROUTES as readonly string[]).includes(
    path
  )

  useInitializeThoughtSpot(isThoughtSpotRoute ? userId : '')

  return (
    <>
      <DashboardHeader />
      {selectedPage?.path === PATH.Dashboard && <Liveboard />}
      {selectedPage?.path === PATH.Campaigns && <Campaigns />}
      {selectedPage?.path === PATH.DataSearch && <DataSearch />}
      {selectedPage?.path === PATH.JaqiAi && <Jaqi />}
      {selectedPage?.path === PATH.MetabaseAccount && (
        <MetabaseAccountOverview />
      )}
      {selectedPage?.path === PATH.MetabaseCampaign && (
        <MetabaseCampaignOverview />
      )}
    </>
  )
}
